"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedState = void 0;
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = require("react");
/**
 * Similar to `useState` but with the ability to provide a function that is
 * called only after `wait` millisecond have elapsed since the last time the state
 * was set. Also keeps in sync with any external changes to `state`.
 */
function useDebouncedState(state, debouncedSetState, wait, options) {
    const [internalState, setInternalState] = (0, react_1.useState)(state);
    // Keep in sync with external state.
    (0, react_1.useEffect)(() => {
        setInternalState(state);
    }, [state]);
    const callback = (0, react_1.useCallback)((0, debounce_1.default)((state) => {
        debouncedSetState(state);
    }, wait, options), []);
    const onSetInternalState = (0, react_1.useCallback)((action) => {
        if (action instanceof Function) {
            setInternalState((prevState) => {
                const state = action(prevState);
                callback(state);
                return state;
            });
        }
        else {
            setInternalState(action);
            callback(action);
        }
    }, []);
    return [internalState, onSetInternalState];
}
exports.useDebouncedState = useDebouncedState;
